import React from 'react'

const FloatingText = () => {
  return (
    <div className=' mt-32 mx-auto p-4 lg:px-8 text-white'>
        <h1 className=' work-inv text-center'> <span className=' text-gray-500'>LETS</span>  WORK  <span className=' text-gray-500'>TOGETHER</span></h1>
    </div>
  )
}

export default FloatingText